import { LogisticStatusEnum } from '@ztechapps/common.contract'

export const LOGISTIC_PRICING_LOCKED_MESSAGE = 'Pricing is locked for a closed record'

/**
 * A closed or cancelled record is frozen against editing. Two separate locks read this one
 * predicate, and it says nothing about which fields either covers — each caller names its own:
 *
 * - the typed half of the quote — the line amounts and whether the carrier charge is included
 *   (`libs/logistic/node/src/repositories/LogisticRepository.ts` → the pricing guard);
 * - every shipping parameter the carrier payload is composed from — shipping origin, ship date,
 *   either side's address, the shipping party, and the rate/carrier selection
 *   (`libs/logistic/node/src/repositories/middlewares/ShippingParameterRepositoryMiddleware.ts`),
 *   plus the shipping weight (`.../actions/LogisticItemUpdateShippingWeight.ts`).
 *
 * **Operating the carrier is not editing, and stays available on such a record:** buying a label
 * and voiding one both still work once closed or cancelled. Re-selecting the rate does not — that
 * is a parameter change, and the label is what gets voided when a parameter moves, so the two
 * cannot both be allowed to move.
 */
export const isLogisticEditLocked = (status: LogisticStatusEnum): boolean =>
  status === LogisticStatusEnum.Closed || status === LogisticStatusEnum.Cancelled
